/**
 * Animations plugin.
 * Provides event handlers for components to bind CSS keyframe animation classes.
 * @param {Object} options
 *
 */
var animations = function(options) {

    var _defaults = {
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});

};

/**
 * Animation for show/hide Foundation dropdown component.
 * @param {jQUery Object} dropdown
 * @param {Integer} duration
 *
 */
animations.prototype.dropdownAnimation = function(element, options) {

    var _defaults = {
        duration: 350,
        animationIn: 'slideInTop',
        animationOut: 'slideOutTop'
    }

    var options =  $.extend({}, _defaults, options || {});

    // animation in
    element.on('show.zf.dropdown', function(e){
        var dropdown = $(e.target);
        dropdown.removeClass(options.animationOut);
        dropdown.addClass(options.animationIn);
    });

    // animation out
    element.on('hide.zf.dropdown', function(e){
        var dropdown = $(e.target);
        dropdown.removeClass(options.animationIn);
        dropdown.addClass(options.animationOut);
    });
};

module.exports = animations;



// WEBPACK FOOTER //
// ./src/resources/js/animations.js